import { Typography, TypographyProps } from '@mui/material';

export const BoldText = ({ children, ...props }: TypographyProps) => {
  return (
    <Typography fontWeight="bold" {...props}>
      {children}
    </Typography>
  );
};
